module.exports = __webpack_public_path__ + "static/media/foto5.6742b871.jpeg";